import React from "react";
import { Box } from "@chakra-ui/react";
import { baseColors } from "../../tokens";

interface TextButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  // Position 관련
  position?: "relative" | "fixed" | "absolute" | "sticky";
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
  top?: number | string;
  // 기타 스타일
  backgroundColor?: string;
  paddingTop?: string;
  zIndex?: number;
  width?: string;
}

export const TextButton: React.FC<TextButtonProps> = ({
  children,
  onClick,
  className,
  position = "relative",
  bottom,
  left,
  right,
  top,
  backgroundColor = baseColors.background_normal,
  paddingTop,
  zIndex,
  width = "100%",
}) => {
  return (
    <Box
      css={{
        position,
        width,
        bottom,
        left,
        right,
        top,
        alignItems: "center",
        zIndex,
        backgroundColor,
        paddingTop,
      }}
    >
      <Box
        textAlign="center"
        className={className || "caption_12_m"}
        margin="0 0 20px"
        onClick={onClick}
        css={{ cursor: "pointer" }}
      >
        <u>{children}</u>
      </Box>
    </Box>
  );
};
